export default {"src":"/_next/static/media/loading.4688e609.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};